// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { COMMON_API } from "../../commonAPI";

// const DSAFormTable = () => {
//   const [dsaForms, setDsaForms] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const rowsPerPage = 10; // rows per page
//   const token = sessionStorage.getItem("authToken");

//   const fetchDSAForms = async () => {
//     try {
//       const res = await axios.get(`${COMMON_API}/loan/getDSAForm`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setDsaForms(res.data.loan || []);
//     } catch (err) {
//       console.error("Error fetching DSA forms:", err);
//     }
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "-";
//     const date = new Date(dateString);
//     return date.toLocaleString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   useEffect(() => {
//     fetchDSAForms();
//   }, []);

//   // pagination logic
//   const indexOfLastRow = currentPage * rowsPerPage;
//   const indexOfFirstRow = indexOfLastRow - rowsPerPage;
//   const currentRows = dsaForms.slice(indexOfFirstRow, indexOfLastRow);
//   const totalPages = Math.ceil(dsaForms.length / rowsPerPage);

//   return (
//     <div className="p-6 bg-gray-100 min-h-screen">
//       <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl mx-auto">
//         <h2 className="text-2xl font-bold mb-4">DSA Form Submissions</h2>
//         <div className="overflow-x-auto">
//           <table className="w-full border-collapse border border-gray-300 text-sm">
//             <thead className="bg-gray-200">
//               <tr>
//                 <th className="border border-gray-300 px-4 py-2">ID</th>
//                 <th className="border border-gray-300 px-4 py-2">Full Name</th>
//                 <th className="border border-gray-300 px-4 py-2">Contact No</th>
//                 <th className="border border-gray-300 px-4 py-2">Phone No</th>
//                 <th className="border border-gray-300 px-4 py-2">PAN No</th>
//                 <th className="border border-gray-300 px-4 py-2">Email</th>
//                 <th className="border border-gray-300 px-4 py-2">GST File</th>
//                 <th className="border border-gray-300 px-4 py-2">Created At</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentRows.map((row) => (
//                 <tr key={row.id} className="hover:bg-gray-50">
//                   <td className="border px-4 py-2">{row.id}</td>
//                   <td className="border px-4 py-2">{row.full_name || "-"}</td>
//                   <td className="border px-4 py-2">{row.contact_no || "-"}</td>
//                   <td className="border px-4 py-2">{row.phone_no || "-"}</td>
//                   <td className="border px-4 py-2">{row.pan_no || "-"}</td>
//                   <td className="border px-4 py-2">{row.email || "-"}</td>
//                   <td className="border px-4 py-2">
//                     {row.gst_img ? (
//                       <a
//                         href={`https://api.mahaarth.com/api/gstUploads/${row.gst_img}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="text-blue-600 underline"
//                       >
//                         View File
//                       </a>
//                     ) : (
//                       "-"
//                     )}
//                   </td>
//                   <td className="border px-4 py-2">{formatDate(row.created_at)}</td>
//                 </tr>
//               ))}
//               {dsaForms.length === 0 && (
//                 <tr>
//                   <td colSpan="8" className="text-center py-3 text-gray-500">
//                     No submissions found.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* pagination controls */}
//         {dsaForms.length > rowsPerPage && (
//           <div className="flex justify-center items-center mt-4 space-x-2">
//             <button
//               disabled={currentPage === 1}
//               onClick={() => setCurrentPage(currentPage - 1)}
//               className={`px-3 py-1 rounded border ${
//                 currentPage === 1
//                   ? "bg-gray-200 cursor-not-allowed"
//                   : "bg-blue-500 text-white"
//               }`}
//             >
//               Prev
//             </button>

//             {[...Array(totalPages)].map((_, index) => (
//               <button
//                 key={index + 1}
//                 onClick={() => setCurrentPage(index + 1)}
//                 className={`px-3 py-1 rounded border ${
//                   currentPage === index + 1
//                     ? "bg-blue-600 text-white"
//                     : "bg-gray-100"
//                 }`}
//               >
//                 {index + 1}
//               </button>
//             ))}

//             <button
//               disabled={currentPage === totalPages}
//               onClick={() => setCurrentPage(currentPage + 1)}
//               className={`px-3 py-1 rounded border ${
//                 currentPage === totalPages
//                   ? "bg-gray-200 cursor-not-allowed"
//                   : "bg-blue-500 text-white"
//               }`}
//             >
//               Next
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default DSAFormTable;


import React, { useEffect, useState } from "react";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

const DSAFormTable = () => {
  const [dsaForms, setDsaForms] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const rowsPerPage = 10; // backend limit
  const token = sessionStorage.getItem("authToken");

  const fetchDSAForms = async (page = 1) => {
    try {
      const res = await axios.get(
        `${COMMON_API}/loan/getDSAForm?page=${page}&limit=${rowsPerPage}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setDsaForms(res.data.loan || []);
      setTotalPages(res.data.pagination?.totalPages || 1);
      setCurrentPage(res.data.pagination?.page || 1);
    } catch (err) {
      console.error("Error fetching DSA forms:", err);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  useEffect(() => {
    fetchDSAForms(currentPage);
  }, [currentPage]);

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">DSA Form Submissions</h2>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300 text-sm">
            <thead className="bg-gray-200">
              <tr>
                <th className="border border-gray-300 px-4 py-2">ID</th>
                <th className="border border-gray-300 px-4 py-2">Full Name</th>
                <th className="border border-gray-300 px-4 py-2">Contact No</th>
                <th className="border border-gray-300 px-4 py-2">Phone No</th>
                <th className="border border-gray-300 px-4 py-2">PAN No</th>
                <th className="border border-gray-300 px-4 py-2">Email</th>
                <th className="border border-gray-300 px-4 py-2">GST File</th>
                <th className="border border-gray-300 px-4 py-2">Created At</th>
              </tr>
            </thead>
            <tbody>
              {dsaForms.map((row) => (
                <tr key={row.id} className="hover:bg-gray-50">
                  <td className="border px-4 py-2">{row.id}</td>
                  <td className="border px-4 py-2">{row.full_name || "-"}</td>
                  <td className="border px-4 py-2">{row.contact_no || "-"}</td>
                  <td className="border px-4 py-2">{row.phone_no || "-"}</td>
                  <td className="border px-4 py-2">{row.pan_no || "-"}</td>
                  <td className="border px-4 py-2">{row.email || "-"}</td>
                  <td className="border px-4 py-2">
                    {row.gst_img ? (
                      <a
                        href={`https://api.mahaarth.com/api/gstUploads/${row.gst_img}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline"
                      >
                        View File
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td className="border px-4 py-2">{formatDate(row.created_at)}</td>
                </tr>
              ))}
              {dsaForms.length === 0 && (
                <tr>
                  <td colSpan="8" className="text-center py-3 text-gray-500">
                    No submissions found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* pagination controls */}
        {totalPages > 1 && (
          <div className="flex justify-center items-center mt-4 space-x-2">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
              className={`px-3 py-1 rounded border ${
                currentPage === 1
                  ? "bg-gray-200 cursor-not-allowed"
                  : "bg-blue-500 text-white"
              }`}
            >
              Prev
            </button>

            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index + 1}
                onClick={() => setCurrentPage(index + 1)}
                className={`px-3 py-1 rounded border ${
                  currentPage === index + 1
                    ? "bg-blue-600 text-white"
                    : "bg-gray-100"
                }`}
              >
                {index + 1}
              </button>
            ))}

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
              className={`px-3 py-1 rounded border ${
                currentPage === totalPages
                  ? "bg-gray-200 cursor-not-allowed"
                  : "bg-blue-500 text-white"
              }`}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DSAFormTable;
